import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { IUiNotificationService } from 'src/app/interfaces';
import { GetConfig } from 'src/app/library-modules/auth-config.module';
import { UiNotificationType } from 'src/app/models';
import { GetTokenUseCase } from 'src/app/use-cases';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit{
  token ="";
  srcUrl="";
  isLoading = true;
  constructor(
    private router: Router,
    private getTokenUseCase: GetTokenUseCase,
    @Inject('IUiNotificationService') private uiNotificationService: IUiNotificationService) { }
  
  ngOnInit(): void {
    this.srcUrl = GetConfig().tableauUrl;
    // this.getToken();
  }

  getToken() {
    this.isLoading = true;

    this.getTokenUseCase.execute()
      .pipe(finalize(() => {
        this.isLoading = false;
        setTimeout(()=>{
          this.checkTableauViz();
        }, 3000)
        
      }))
      .subscribe({
        next: (response: string) => {
          this.token = response;
          // console.log(this.token);
          
        }
      });
  }

  checkTableauViz()
  {
     if(document.querySelector("body")?.querySelector('tableau-viz')?.shadowRoot?.querySelector('iframe')?.contentDocument != null)
     {
      this.uiNotificationService.showNotification(
        UiNotificationType.Warning,
        "No access to tableau reports");
        this.router.navigate(['/unauthorized']);
     }
  }
}


